import { atom } from 'jotai/index'
import { UserDetailResponse } from 'sierra-domain/api/manage'

export const userDetailDataAtom = atom<UserDetailResponse | undefined>(undefined)
